import React, { useState } from 'react';
import { Form, Input, Button, Typography, Steps, Alert, message } from 'antd';
import { MailOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { authApi } from '../../services/auth';
import { ROUTES } from '../../config/routes';
import { COLORS } from '../../constants/colors';

const { Text, Title } = Typography;
const { Step } = Steps;

export const ForgotPassword: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [email, setEmail] = useState('');

  const handleSubmit = async (values: { email: string }) => {
    setLoading(true);
    try {
      await authApi.forgotPassword({ email: values.email });
      setEmail(values.email);
      setCurrentStep(1);
      message.success('重置密码邮件已发送');
    } catch (error) {
      // 错误已在request拦截器中处理
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Steps current={currentStep} size="small" style={{ marginBottom: 24 }}>
        <Step title="输入邮箱" />
        <Step title="发送成功" />
      </Steps>

      {currentStep === 0 && (
        <Form
          name="forgotPassword"
          onFinish={handleSubmit}
          size="large"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: '请输入邮箱' },
              {
                validator: (_: unknown, value: string) => {
                  if (!value || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('请输入有效的邮箱地址'));
                },
              },
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="注册时使用的邮箱"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              发送重置链接
            </Button>
          </Form.Item>
        </Form>
      )}

      {currentStep === 1 && (
        <div style={{ textAlign: 'center', padding: '24px 0' }}>
          <CheckCircleOutlined style={{ fontSize: 64, color: COLORS.success, marginBottom: 16 }} />
          <Title level={4}>邮件已发送</Title>
          <Text type="secondary">
            重置密码链接已发送至 {email}，请查收邮件并按提示操作。
          </Text>
          <Alert
            message="提示"
            description="邮件可能需要几分钟才能到达，请检查垃圾邮件文件夹。"
            type="info"
            showIcon
            style={{ marginTop: 16, textAlign: 'left' }}
          />
        </div>
      )}

      <div style={{ textAlign: 'center', marginTop: 16 }}>
        <Text type="secondary">
          <Link to={ROUTES.LOGIN}>返回登录</Link>
        </Text>
      </div>
    </>
  );
};
